import React from "react";
import Section from "../components/primatives/Section";
import Input from "../components/primatives/Input";
import SectionHeader from "../components/primatives/SectionHeader";
import ActionButton from "../components/primatives/ActionButton";

import {
  FiSmartphone,
} from "react-icons/fi";

import state from "../helpers/state";
import { toast } from "react-toastify";

class VerifyPhone extends React.Component {
  constructor(props) {
    super(props);

    // also receives: this.props.phoneNumber
    this.state = {
      verifyCode: "", //  used for acct creation
      randomlyGeneratedKeys: {}, //  used for acct creation
      isLoading: false,
      loadState: props.helpers.loadState(),
    };
  }

  verifyPhoneCode = async (e) => {
    e.preventDefault();

    // verifies a phone number...
    this.setState({ isLoading: true });

    const put = this.props.helpers.put();
    const sls = this.props.helpers.sls();



    // gen keys
    let freshKeys = await put.keypair();
    // test code for correctness..
    let accountCreated = await sls.verify(
      this.props.phoneNumber,
      this.state.verifyCode,
      freshKeys.active.publicKey,
      freshKeys.owner.publicKey
    );

    if (accountCreated) {
      // everything was a success, save keys to localstorage..
      let backup = true;
      state.set("backup", backup); // store in localstorage
      // update the "login" form with new user account
      this.props.updateUsername(accountCreated);
      this.props.updateKey(freshKeys.active.privateKey);

      // launch confetti
      this.props.helpers.launchConfetti();

      // login
      toast.success("Phone verified!");
      this.props.login();   // auto login with new acct

    } else {
      // could not verify account.
      toast.error("Could not validate code.");
    }

    this.setState({ isLoading: false });
  };

  render() {

    // code attempting to be verified (show code form)
    return (
      <Section>
        <form onSubmit={this.verifyPhoneCode}>
          <div className="mb-6">
            <SectionHeader>
              <FiSmartphone /> Verify Phone
            </SectionHeader>
            <p className="text-gray-500 text-xs mb-2">
              Enter the code sent to {this.props.phoneNumber}.
            </p>
            <Input
              type="text"
              placeholder="876202"
              value={this.state.verifyCode}
              onChange={(e) => this.setState({ verifyCode: e.target.value })}
              required={true}
            />
          </div>
          <div className="flex items-lcentereft justify-between">
            <ActionButton
              type="submit"
              style={{ maxWidth: "110px" }}
              isLoading={this.state.isLoading}
            >
              Verify
            </ActionButton>

            <div>&nbsp;</div>

            <button className="inline-block align-baseline font-bold text-sm text-indigo-500 hover:text-indigo-800">
              <a href="https://put.dev/#start">Need another code?</a>
            </button>
          </div>
        </form>
      </Section>
    );
  }
}

export default VerifyPhone;
